import React, { useEffect, useState } from 'react';
import EcranPassage from './connexion/EcranPassage';
import {
  lireEcrans, momentPour, segments, civiliteDe, heureDe, nomEcoleDe
} from './connexion/contenusEcrans';

/**
 * Écran d'accueil de l'administration, juste après la connexion : l'école
 * s'éveille sous le soleil. Textes et horaires journée/soirée réglés dans le
 * CIK (Page de connexion → Écrans d'accueil et d'au revoir).
 * Ancienne version : components/dump/WelcomeScreen-V1-avant-refonte.jsx
 */
const WelcomeScreen = ({ user }) => {
  const [maintenant, setMaintenant] = useState(new Date());
  // Lu une fois : l'écran ne change pas de textes ni de décor en cours de route
  const [ecrans] = useState(lireEcrans);
  const [moment] = useState(() => momentPour(ecrans.horaires));

  useEffect(() => {
    const timer = setInterval(() => setMaintenant(new Date()), 1000);

    const timeout = setTimeout(() => {
      const storedTarget = localStorage.getItem('redirectTo') || '/administration';
      const redirectTarget = storedTarget === '/admin' ? '/administration' : storedTarget;
      window.location.href = redirectTarget;
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, []);

  const valeurs = {
    civilite: civiliteDe(user?.sexe),
    nom: user?.nom,
    ecole: nomEcoleDe(user),
    heure: heureDe(maintenant)
  };
  const textes = ecrans.accueil;

  return (
    <EcranPassage
      sens="arrivee"
      moment={moment}
      titre={segments(textes[moment], valeurs, [])}
      ligne={segments(textes.ecole, valeurs)}
      phrase={segments(textes.heure, valeurs, [])}
      icone="horloge"
      duree={3}
    />
  );
};

export default WelcomeScreen;
